/* eslint-disable */
import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { components } from 'react-select'
import capitalize from 'utils/capitalize'

import Button from 'components/Button'
import Select from 'components/Select'
import ActionsMenu from 'features/ActionMenu'
import RemoveIcon from 'assets/icons/remove-icon16px'

import {
  requestAddNewCoProposer,
  requestGetPotentialCoProposers,
  requestGetSite,
  requestGetSiteCoProposers,
  requestUpdateSite,
  requestRemoveCoProposerFromSite
} from 'api/site'
import Input from 'components/Input'
import AddCoProposerMenu from 'features/AddCoProposerMenu'
import IconsRow from 'components/IconsRow'
import { delay } from 'utils/delay'

import {
  ManageUserDropdownItem,
  ManageUserWrapper,
  ManageUserAvatar,
  ManageUserName,
  UserAvatar,
  UserName,
  UserEmail,
  ManageUsersLabel,
  ManageUsersSeparator
} from './style'



const formatSiteCoProposerList = (options, updateList) => {
  const params = useParams()
  return options.map((coProposer) => {
    const dropdownItems = [
      {
        icon: <RemoveIcon />,
        title: 'remove',
        isDestructive: true,
        onClick: async () => {
          await requestRemoveCoProposerFromSite({ siteId: coProposer.SiteId, proposerId: coProposer.id }, params.siteHistoryId)
          updateList()
        }
      }
    ]
    return {
      label: (
        <ManageUserDropdownItem>
         <ManageUserWrapper>
           <ManageUserAvatar>
             <UserAvatar>{coProposer.User.firstName.charAt(0).toUpperCase()}</UserAvatar>
           </ManageUserAvatar>
           <ManageUserName>
             <UserName>
               {capitalize(coProposer.User.lastName)} {capitalize(coProposer.User.firstName)}
             </UserName>
             <UserEmail>{coProposer.User.email}</UserEmail>
           </ManageUserName>
         </ManageUserWrapper>
          <div>
            <ActionsMenu table={false} manageCo={true} dropdownItems={dropdownItems} />
          </div>
        </ManageUserDropdownItem>
      ),
      value: 'yes',
      User: {firstName: coProposer.User.firstName}
    }
  })
}

const ManageCoProposerSelectPlaceholder = (placeholderId, options) => {
  return function Placeholder(props) {
    return (
      <components.Placeholder {...props}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ManageUsersLabel>
            <FormattedMessage id={placeholderId} />
          </ManageUsersLabel>
          <ManageUsersSeparator />
          <IconsRow usersList={options} />
        </div>
      </components.Placeholder>
    )
  }
}

let coProposerFetchAbortController = null
const searchStartLength = 3
const inputSaveDelayTime = 300
const searchPotentialCoProposersDelay = delay(inputSaveDelayTime)
const ManageCoProposersModal = ({ toggleModal }) => {
  const params = useParams()
  const [site, setSite] = useState({ name: '' })
  const [siteName, setSiteName] = useState('')
  const [chips, setChips] = useState([])
  const [potentialCoProposers, setPotentialCoProposer] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [siteCoProposers, setSiteCoProposers] = useState([])
  const inputRef = useRef(null)

  const isAbleToAddCoProposers = () => {
    const checkInExistentUser = chips.every((chip) => {
      return chip.firstName
    })
    if ((site.name || siteName.length) && chips.length && checkInExistentUser) {
      return true
    }
  }

  function getPotentialCoProposers() {
    if (coProposerFetchAbortController) {
      coProposerFetchAbortController.abort()
    }
    coProposerFetchAbortController = new AbortController()
    const excludeIds = [
      ...chips.filter((item) => {
        return typeof item.id === 'string'
      }).map((user) => {
        return user.id
      }),
      ...siteCoProposers.map((proposer) => {
        return proposer.UserId
      })
    ]
    searchPotentialCoProposersDelay(()=>{
      requestGetPotentialCoProposers({ searchQuery, excludeIds }).then((data) => {
        setPotentialCoProposer(data.potentialProposers)
      })
    })
  }

  function getSiteCoProposers() {
    requestGetSiteCoProposers(params.id, params.siteHistoryId).then((data) => {
      const result = params.siteHistoryId ? data : data.siteCoProposers
      setSiteCoProposers(result)
    })
  }

  async function addNewSiteName() {
    const data = await requestUpdateSite(site.id, params.siteHistoryId, { name: siteName })
    setSiteName('')
    setSite(data)
  }

  async function addNewCoProposer() {
    if (!site.name) {
      await addNewSiteName()
    }
    const newProposers = chips.map((chip) => {
      return chip.id
    })

    await requestAddNewCoProposer({ siteId: params.id, newProposers }, params.siteHistoryId)
    setChips([])
    await getSiteCoProposers()
  }

  function getSite() {
    requestGetSite(params.id, params.siteHistoryId).then((data) => {
      setSite(data)
    })
  }

  useEffect(() => {
    if (searchQuery.length >= searchStartLength) {
      getPotentialCoProposers()
    } else {
      setPotentialCoProposer([])
    }
  }, [searchQuery])

  useEffect(() => {
    getSiteCoProposers()
    getSite()
  }, [])

  function onEnterPress(e) {
    const enterKey = 13
    if (e.keyCode === enterKey) {
      const found = potentialCoProposers.find((user) => {
        return user.email === e.target.value
      })
      if (found) {
        setChips([...chips, found])
        setSearchQuery('')
        return
      }
      setChips([...chips, { email: e.target.value, id: Math.random(), firstName: '' }])
      setSearchQuery('')
    }
  }

  function handleChangeSearchQuery(e) {
    setSearchQuery(e.target.value)
  }

  function handleSelect(user) {
    setChips([...chips, user])
    setSearchQuery('')
    setPotentialCoProposer([])
    inputRef.current?.blur()
  }

  function makeFocus(e) {
    e.preventDefault()
    inputRef.current?.focus()
  }

  function handleInputSiteName(e) {
    setSiteName(e.target.value)
  }

  const formattedCoProposersList = useMemo(()=>{
    return formatSiteCoProposerList(siteCoProposers, getSiteCoProposers)
  },[siteCoProposers])

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {!site.name && (
          <Input
            dataTest="site-name-input"
            placeholder="enterSitename"
            value={siteName}
            onChange={handleInputSiteName}
          />
        )}
      </div>
      <AddCoProposerMenu
        makeFocus={makeFocus}
        inputRef={inputRef}
        searchQuery={searchQuery}
        handleChangeQuery={handleChangeSearchQuery}
        chips={chips}
        handleSelect={handleSelect}
        potentialCoProposers={potentialCoProposers}
        setChips={setChips}
        setQuery={setSearchQuery}
        onEnterPress={onEnterPress}
      />
      {siteCoProposers.length > 0 && (
        <Select
          placeholderComponent={ManageCoProposerSelectPlaceholder(
            'manageUsers',
            formatSiteCoProposerList(siteCoProposers)
          )}
          field="manageUsers"
          value={null}
          options={formattedCoProposersList}
          height="48px"
          placeholder="manageUsers"
          menuPlacement="bottom"
          closeMenuOnSelect={false}
          marginBottom="16px"
        />
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ marginRight: '16px' }}>
          <Button dataTest="cancel" type="secondary" onClick={toggleModal} marginTop="24px">
            <FormattedMessage id="cancel" />
          </Button>
        </div>
        <Button
          dataTest="submit"
          type={isAbleToAddCoProposers()? 'primary' : 'disabledPrimary'}
          onClick={addNewCoProposer}
          isDisabled={!isAbleToAddCoProposers()}
          marginTop="24px"
        >
          <FormattedMessage id="sendInvites" />
        </Button>
      </div>
    </div>
  )
}

export default ManageCoProposersModal
